import styled from "styled-components";

export const WalletHistoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 26px 17px 60px;
`;

export const WalletHistoryContentsWrapper = styled.div`
  background: var(--Black-100, #f0f0f0);
  width: 100%;
  border-radius: 8px;
  padding: 16px 16px 27px;

  > .title {
    font-weight: 600;
    font-size: 15px;
    color: var(--Black-500, #202020);
  }
`;

export const WalletHistoryListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 12px;
`;
